import * as Yup from 'yup';

const schema = Yup.object().shape({
  cardExpiration: Yup.string()
    .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, 'Invalid format')
    .test('expiry-not-in-past', 'Card has expired', (value) => {
      if (!value) return false;
      const [monthStr, yearStr] = value.split('/');
      const month = parseInt(monthStr, 10);
      const year = 2000 + parseInt(yearStr, 10);

      const now = new Date();
      const expiry = new Date(year, month - 1, 1);
      expiry.setMonth(expiry.getMonth() + 1); // Card expires end of the month

      return expiry > now;
    })
    .required('Required'),
});

export default schema;
